import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormBuilder, Validators } from '@angular/forms';
import { Message } from 'primeng/api';

import { AppSettings } from '../../../shared/app.settings';
import { UserCommonService } from './../../services/user-common.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  @Output() onPopClose: EventEmitter<any> = new EventEmitter();
  @Output() onPopSave: EventEmitter<any> = new EventEmitter();
  message: Message[] = [];
  isSubmitting = false;
  editforgotForm = new UntypedFormGroup({
    username: new UntypedFormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private commonServices: UserCommonService,
    private uiService: UiService
  ) { }

  ngOnInit() {
    this.editforgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]],
    });
  }

  closeEditForgot(event) {
    if (this.isSubmitting) {
      return;
    }
    this.editforgotForm.reset();
    this.onPopClose.emit();
  }

  changePassword(event) {
    if (this.isSubmitting || this.editforgotForm.invalid) {
      this.editforgotForm.markAllAsTouched();
      return;
    }

    this.message = [];
    let input;
    let otpEmail;
    let otpPhone;

    const userName = this.editforgotForm.controls.username.value;
    if (userName.match(AppSettings.EMAIL_PATTERN)) {
      otpEmail = userName;
      input = {
        email: userName,
        tenantId: AppSettings.TENANT
      };
    } else if (userName.match(AppSettings.COMMON_PHONE_NUMBER_REGEX)) {
      otpPhone = userName;
      input = {
        phoneNum: userName,
        tenantId: AppSettings.TENANT
      };
    } else {
      input = {
        username: userName,
        tenantId: AppSettings.TENANT
      };
    }

    this.isSubmitting = true;
    this.commonServices.forgotPassword(JSON.stringify(input)).subscribe(results => {
      this.isSubmitting = false;
      results.email = otpEmail;
      results.phone = otpPhone;
      this.onPopSave.emit(results);
      this.editforgotForm.reset();
    }, (error) => {
      this.isSubmitting = false;
      this.showErrorToast(error);
    });
  }

  private showErrorToast(error) {
    const message = this.getApiErrorMessage(error);
    if (message) {
      this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.ERROR);
    }
  }

  private getApiErrorMessage(error): string {
    if (!error) {
      return '';
    }
    for (const key of Object.keys(error)) {
      if (Array.isArray(error[key]) && error[key][0]?.message) {
        return error[key][0].message;
      }
    }
    return '';
  }
}
